<script setup lang="ts">
import { computed, useAttrs } from 'vue'

import Icon from '../icon/Icon.vue'
import { IconName } from '../icon/helpers'

defineOptions({
  inheritAttrs: false,
})

const attrs = useAttrs()

const model = defineModel<any>({
  default: undefined,
})

const inputAttrs = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { class: _class, ...rest } = attrs
  return rest
})
</script>

<template>
  <span class="glp-checkbox" :class="attrs.class">
    <input
      v-bind="inputAttrs"
      v-model="model"
      type="checkbox"
      class="glp-checkbox__input"
    />
    <Icon :name="IconName.Check" class="glp-checkbox__marker" />
  </span>
</template>

<style>
.glp-checkbox {
  display: inline-grid;
  /* Prevent shrinking if used in a grid or flexbox */
  min-width: var(--glp-checkbox-size, 24px);
  max-width: var(--glp-checkbox-size, 24px);
  height: auto;
  aspect-ratio: 1/1;
  place-items: center;
  border-radius: var(--glp-checkbox-border-radius, 4px);
  border: var(--glp-checkbox-border-width, 1px) solid
    var(--glp-checkbox-color-border, #8c78ff);
  background: var(
    --glp-checkbox-background,
    var(--glp-checkbox-default-background)
  );
  color: var(--glp-checkbox-foreground, #fff);
}

.glp-checkbox__input {
  grid-area: 1 / 1;
  z-index: 1;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  appearance: none;
  border: none;
}
.glp-checkbox__marker {
  grid-area: 1 / 1;
  width: var(--glp-checkbox-size-tick);
  height: var(--glp-checkbox-size-tick);
}
.glp-checkbox__input:not(:checked) + .glp-checkbox__marker {
  visibility: hidden;
}

/* States */
.glp-checkbox:has(:disabled) {
  pointer-events: none;
  opacity: 0.5;
}
.glp-checkbox:hover {
  --glp-checkbox-background: var(--glp-checkbox-hover-background);
}
.glp-checkbox:active {
  --glp-checkbox-background: var(--glp-checkbox-pressed-background);
}
.glp-checkbox:has(:checked) {
  --glp-checkbox-background: var(--glp-checkbox-selected-background);
  --glp-checkbox-foreground: var(--glp-checkbox-selected-foreground);
}
.glp-checkbox:has(:focus-visible) {
  outline: 3px solid var(--glp-general-color-focus);
  outline-offset: 3px;
  isolation: isolate; /** Ensure focus ring stacks above other elements */
}
</style>
